import { Injectable } from "@angular/core";
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PreviewDocumentsComponent } from "./preview-documents.component";
import { CartOrderConfiguration } from "../cart-order/cart-order.configuration";

@Injectable({
    providedIn: 'root',
})

export class PreviewDocumentService{

  constructor(private _dialog: MatDialog) {}

  open = () => this._dialog.open(PreviewDocumentsComponent, { disableClose: true });

}